import BackspaceIcon from '@mui/icons-material/Backspace'
import { Fade, Grid } from '@mui/material'
import { KeyboardButton } from 'components/atoms/KeyboardButton'
import { useBetContext } from 'contexts/BetContext'
import { BETS_CONFIG } from 'models/betTypes'
import { useEffect, useState } from 'react'

export const BetKeyboard = () => {
    const { setBetStake, focusedInputId, selectedBetType, selectedBets } =
        useBetContext()
    const [freeTyping, setFreeTyping] = useState(false)
    const [isSwitchingTypeMode, setIsSwitchingTypeMode] = useState(false)

    const [focusedButton, setFocusedButton] = useState<number | string | null>(
        null
    )

    const currentBetAmount = selectedBets.get(focusedInputId!)?.stake || 0
    const currentMinBet = BETS_CONFIG[selectedBetType]?.minBet || 0

    const betButtons = [
        0.1,
        0.2,
        0.5,
        1,
        2,
        5,
        10,
        20,
        50,
        100,
        200,
        'Saisie libre'
    ]

    const freeTypingButtons = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        'Retour',
        0,
        <BackspaceIcon key="del-icon" fontSize="medium" />
    ]

    useEffect(() => {
        setFocusedButton(null)
    }, [freeTyping])

    if (!focusedInputId) return null

    return (
        <Fade
            in={!isSwitchingTypeMode}
            onExited={() => {
                setFreeTyping(!freeTyping)
                setIsSwitchingTypeMode(false)
                setBetStake(focusedInputId, 0)
            }}
        >
            <Grid
                container
                spacing={1}
                columns={3}
                sx={{ p: 2, backgroundColor: 'white' }}
            >
                {(freeTyping ? freeTypingButtons : betButtons).map((button) => {
                    const isNumber = typeof button === 'number'
                    const isFocused =
                        focusedButton === button ||
                        (!freeTyping && currentBetAmount === button)

                    return (
                        <Grid item xs={1} key={`button-${button}`}>
                            <KeyboardButton
                                textSx={{
                                    fontSize: isNumber ? 20 : 14
                                }}
                                disabled={
                                    (selectedBetType === 'S' &&
                                        isNumber &&
                                        !freeTyping &&
                                        button < 1) ||
                                    (typeof button === 'number'
                                        ? currentMinBet > button && !freeTyping
                                        : false)
                                }
                                focused={isFocused}
                                onClick={() => {
                                    if (!isNumber) {
                                        if (typeof button === 'string')
                                            return setIsSwitchingTypeMode(true)

                                        // Delete button
                                        const newStake =
                                            currentBetAmount
                                                ?.toString()
                                                .slice(0, -1) || 0
                                        return setBetStake(
                                            focusedInputId,
                                            +newStake
                                        )
                                    }

                                    if (!freeTyping) {
                                        if (focusedButton === button) {
                                            setFocusedButton(null)
                                            return setBetStake(
                                                focusedInputId,
                                                undefined
                                            )
                                        }
                                        setFocusedButton(button)
                                        setBetStake(focusedInputId, button)
                                    } else {
                                        const newStake =
                                            currentBetAmount?.toString() || ''

                                        setBetStake(
                                            focusedInputId,
                                            +newStake.concat(button.toString())
                                        )
                                    }
                                }}
                            >
                                {isNumber && button < 1 && button > 0
                                    ? button.toFixed(2).replace('.', ',')
                                    : button}{' '}
                                {isNumber && !freeTyping ? '€' : ''}
                            </KeyboardButton>
                        </Grid>
                    )
                })}
            </Grid>
        </Fade>
    )
}
